module.exports = __webpack_public_path__ + "static/media/yellowFlower.1d15ab2f.png";